import Proxy from '../Proxy';

class OrderProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('', parameters);
  }

  addToSheet(type, uuid) {
    return this.submit('post', `orders/google-sheets-payment/${type}/${uuid}`);
  }

  cloneOrder({ uuid, type }) {
    return this.submit('post', `orders/clone/${type}/${uuid}`);
  }
}

export default OrderProxy;
